import { useParams } from 'react-router-dom'
import ProposalPDFContent from './ProposalPDFContent'
import './ProposalPDF.css'

// Acesso direto/favoritado da URL: mostra um loading e troca a própria aba pelo PDF gerado.
function ProposalPDF() {
    const { id } = useParams()

    return (
        <div className='pdf-route-wrapper'>
            <div className='pdf-loading-overlay'>
                <div className='pdf-loading-spinner' />
                <p>Gerando proposta...</p>
            </div>
            <ProposalPDFContent id={id} onReady={(url) => { window.location.href = url }} />
        </div>
    )
}

export default ProposalPDF
